import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaBalanceScale, FaSearch, FaGavel, FaUsers, FaMobileAlt, FaLock, FaCheckCircle, FaCalendarAlt, FaCode, FaRocket } from 'react-icons/fa';
import Button from '../../components/Button';

const WebAbogadosPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: '/servicios/diseno-web-pymes', text: 'Páginas web baratas para PYMES' },
    { url: '/servicios/diseno-web-autonomos', text: 'Páginas web baratas para autónomos' },
    { url: '/servicios/diseno-web-inmobiliarias', text: 'Páginas web baratas para inmobiliarias' },
    { url: '/servicios/diseno-web-empresas', text: 'Páginas web baratas para empresas' },
    { url: '/servicios/diseno-web-psicologos', text: 'Páginas web baratas para psicólogos' },
    { url: '/precios', text: 'Ver todos nuestros precios' }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Consigue clientes mientras estás en el juzgado",
      description: "Tu web captura consultas 24/7, incluso cuando estás ocupado con casos o en el juzgado. Imagina revisar tu email después de una jornada y encontrar solicitudes de presupuesto."
    },
    {
      title: "Diferénciate de los grandes bufetes sin gastar fortunas",
      description: "No necesitas invertir miles de euros como los grandes despachos. Nuestra web te da imagen profesional a precio asequible, ideal para abogados independientes o pequeños bufetes."
    },
    {
      title: "Tus clientes te buscan en Google, no en las Páginas Amarillas",
      description: "El 87% de las personas busca servicios legales en internet. Sin presencia online, esos clientes acaban con tu competencia, y nunca sabrás cuántos has perdido."
    },
    {
      title: "Genera confianza desde el primer vistazo",
      description: "En el sector legal la primera impresión es crucial. Una web bien diseñada transmite profesionalidad y seriedad, haciendo que potenciales clientes confíen en ti antes de conocerte."
    },
    {
      title: "Simple de gestionar, sin conocimientos técnicos",
      description: "Te entregamos una web que no requiere mantenimiento por tu parte. Dedica tu tiempo a tus casos, no a problemas técnicos con WordPress o plugins."
    },
    {
      title: "Retorno de inversión rápido y medible",
      description: "Con un solo cliente que contacte a través de tu web, ya habrás recuperado la inversión. La mayoría de nuestros clientes abogados consiguen su primer cliente online en menos de 30 días."
    }
  ];
  
  // Características adaptadas al buyer persona
  const features = [
    {
      icon: <FaBalanceScale />,
      title: "Diseñada específicamente para captar clientes legales",
      description: "Tu web incluirá elementos específicos para el sector legal: secciones para cada especialidad, explicaciones claras de procesos legales y formularios de consulta adaptados a casos jurídicos."
    },
    {
      icon: <FaSearch />,
      title: "Optimizada para búsquedas locales",
      description: "Configuramos tu web para que aparezca cuando alguien busque 'abogado cerca de mí' o 'abogado en [tu ciudad]', captando clientes de tu zona geográfica."
    },
    {
      icon: <FaGavel />,
      title: "Presentación profesional de tus servicios",
      description: "Destacamos tus áreas de práctica, experiencia y casos de éxito (manteniendo la confidencialidad) para generar autoridad y confianza en tu sector."
    },
    {
      icon: <FaUsers />,
      title: "Sección de testimonios estratégica",
      description: "Incluimos una sección para opiniones de clientes satisfechos (sin nombres completos para mantener privacidad), lo que aumenta significativamente la tasa de conversión."
    },
    {
      icon: <FaMobileAlt />,
      title: "Perfecta en móviles y tablets",
      description: "El 76% de las búsquedas de servicios legales se realizan desde el móvil. Tu web estará optimizada para todos los dispositivos, con botones de contacto accesibles."
    },
    {
      icon: <FaLock />,
      title: "100% conforme con normativa legal",
      description: "Incluimos todas las políticas necesarias para cumplir con RGPD, LSSI y normativas específicas para abogados, evitándote problemas con el Colegio de Abogados."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para abogados que necesitan una web sencilla pero efectiva para empezar a captar clientes.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por despachos. Equilibrio perfecto entre precio y funcionalidades para generar más consultas.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para bufetes que quieren destacar con más funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Consulta inicial confidencial",
      description: "Hablamos sobre tu práctica legal, especialidades y objetivos. Entendemos tu visión profesional y aclaramos cualquier duda sobre el proceso, sin compromisos ni tecnicismos.",
      icon: <FaCalendarAlt />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en 7 días",
      description: "Creamos tu web jurídica con énfasis en profesionalidad y generación de confianza. Te mantenemos informado y mostramos avances para que puedas solicitar ajustes si lo necesitas.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y primeros resultados",
      description: "Activamos tu web y te enseñamos cómo aprovecharla. Te explicamos cómo gestionar las solicitudes de clientes y qué puedes esperar en términos de contactos y visibilidad.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Web enfocada en captación de clientes",
      us: true,
      others: false
    },
    {
      label: "Precio final sin sorpresas",
      us: true,
      others: false
    },
    {
      label: "Lista en solo 7 días",
      us: true,
      others: false
    },
    {
      label: "Optimizada para buscadores (SEO)",
      us: true,
      others: false
    },
    {
      label: "Sin mantenimientos complicados",
      us: true,
      others: false
    },
    {
      label: "Textos legales específicos incluidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Como abogado independiente, buscaba una solución profesional pero asequible. Otras agencias me pedían 2.000€ por una web básica. Con Web a Bajo Coste obtuve una página elegante, que cumple con todas las normativas y, lo más importante, que me ha traído 5 nuevos clientes en dos meses.",
    author: "Carlos Martínez",
    position: "Abogado Especialista en Derecho Civil",
    company: "Asesoría Jurídica Martínez",
    avatar: "/servicios/testimonios/abogado.webp"
  };
  
  // FAQs específicas para abogados
  const faqs = [
    {
      question: "¿Por qué un abogado necesita una web en 2023?",
      answer: "Hoy en día, el 87% de las personas buscan servicios legales en internet antes de tomar una decisión. Sin presencia online, esos potenciales clientes acaban con tu competencia. Una web profesional te permite captar consultas 24/7, construir credibilidad, y diferenciarte en un mercado saturado. En el sector legal, donde la confianza es fundamental, una web bien diseñada es tu mejor carta de presentación digital.",
      category: "General"
    },
    {
      question: "¿Cómo sé que la inversión en una web me traerá clientes?",
      answer: "La mayoría de nuestros clientes abogados recuperan la inversión con el primer cliente captado a través de la web. Con un diseño orientado a la conversión y optimización para búsquedas locales como 'abogado en [tu ciudad]', aumentamos significativamente tus posibilidades de captación. Además, te ayudamos a medir el retorno con herramientas de seguimiento, para que sepas exactamente cuántos contactos genera tu web mensualmente.",
      category: "Inversión"
    },
    {
      question: "¿Mi web cumplirá con todas las normativas legales?",
      answer: "Absolutamente. Entendemos que como abogado, cumplir la legislación es especialmente importante. Incluimos todos los textos legales necesarios (RGPD, LSSI, política de cookies, aviso legal) adaptados específicamente al sector legal. También respetamos las normativas de los Colegios de Abogados en cuanto a publicidad de servicios jurídicos, asegurándonos de que tu web sea 100% conforme con la deontología profesional.",
      category: "Legal"
    },
    {
      question: "No tengo tiempo para gestionar una web, ¿requiere mucho mantenimiento?",
      answer: "Entendemos que tu tiempo es valioso y debe dedicarse a tus clientes. Por eso creamos webs que no requieren gestión técnica por tu parte. El mantenimiento mensual de 20€ incluye todas las actualizaciones técnicas necesarias, copias de seguridad y soporte. Si necesitas realizar cambios de contenido, podemos hacerlos por ti o enseñarte lo básico en menos de 30 minutos.",
      category: "Mantenimiento"
    },
    {
      question: "¿Cómo protegemos la confidencialidad en una web legal?",
      answer: "La confidencialidad es primordial en el sector legal. Diseñamos las secciones de casos de éxito y testimonios sin revelar datos sensibles de clientes. Implementamos formularios de contacto con advertencias de confidencialidad y transmisión segura de datos. Además, la web incluirá un certificado SSL para garantizar que todas las comunicaciones estén encriptadas, protegiendo la información sensible que tus potenciales clientes puedan compartir.",
      category: "Confidencialidad"
    },
    {
      question: "¿Por qué elegir vuestra solución frente a plataformas como Wix o WordPress?",
      answer: "Aunque plataformas como Wix o WordPress parecen más baratas inicialmente, terminan costando más en tiempo y resultados. Mientras estas soluciones genéricas ofrecen plantillas estándar, nosotros creamos webs específicamente diseñadas para captar clientes legales, con secciones adaptadas a tu especialidad jurídica y elementos de confianza propios del sector. Además, nos encargamos de todo el proceso técnico, permitiéndote centrarte en lo que mejor sabes hacer: ejercer el derecho.",
      category: "Comparativa"
    }
  ];

  const founderMessage = "Desarrollando webs para despachos, he observado que muchos abogados gastan miles de euros en soluciones complejas que no necesitan. Un bufete requiere una web que transmita profesionalidad y confianza, pero no tiene por qué ser costosa o complicada de mantener. Nuestro enfoque es simple: webs elegantes y eficaces que generen consultas reales.";

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para abogados
      pageTitle="Página Web para Abogados desde 200€ | Sin Permanencia, Resultados Garantizados"
      pageDescription="Diseñamos páginas web profesionales para abogados desde 200€. Optimizadas para captar clientes, conformes con normativas legales y listas en 7 días."
      pageKeywords="página web barata abogados, diseño web despachos, web para abogados, página web bufete, web económica sector legal"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-abogados"
      
      // Hero adaptado al buyer persona
      heroTitle="Web profesional para abogados desde solo 200€"
      heroSubtitle="Diseñamos webs que transmiten seriedad, generan confianza y convierten visitas en consultas. Sin costes ocultos, sin conocimientos técnicos, lista en 7 días."
      heroImage="/servicios/tipo-cliente/abogados-hero.webp"
      badges={['Desde 200€ (pago único)', 'Optimizada para SEO local', 'Conforme con normativas', 'Soporte incluido']}
      heroCTAText="Consulta gratuita sin compromiso"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de abogado"
      pricingSubtitle="Elige el plan que mejor se adapte a tu despacho. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="Webs diseñadas específicamente para el sector legal"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Miguel Vela"
            founderTitle="Co-fundador y Director de Desarrollo"
            avatarSrc="/sobre nosotros/foto-miguel.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Así creamos tu web: proceso eficiente y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué los abogados nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu despacho?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para abogados"
      faqCategories={["General", "Inversión", "Legal", "Mantenimiento", "Confidencialidad", "Comparativa"]}
      faqs={faqs}
      
      ctaTitle="¿Listo para captar más clientes con tu web profesional?"
      ctaDescription="Da el primer paso hacia una presencia online que genere consultas reales para tu despacho"
      ctaButtonText="Solicitar información sin compromiso"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebAbogadosPage; 

